// Angular imports
import { Injector } from '@angular/core';

// Constant imports
import { StringFormatConstants } from '../../_constants/string-format-constants';

// Service imports
import { UserService } from '../../_services/data-services/user.service';
import { HelperService } from '../../_services/shared-services/helper.service';
import { ScreenService } from '../../_services/shared-services/screen.service';
import { ServerErrorService } from '../../_services/shared-services/server-error.service';
import { PortfolioHelperService } from '../_services/portfolio-helper.service';

export abstract class UserPortfolioBaseComponent {
    protected userService: UserService;
    protected helperService: HelperService;
    protected screenService: ScreenService;
    protected errorService: ServerErrorService;
    protected portfolioHelper: PortfolioHelperService;

    isSmallScreen = false;
    dateFormat = StringFormatConstants.dateFormat;

    constructor(protected readonly injector: Injector) {
        this.userService = injector.get(UserService);
        this.helperService = injector.get(HelperService);
        this.screenService = injector.get(ScreenService);
        this.errorService = injector.get(ServerErrorService);
        this.portfolioHelper = injector.get(PortfolioHelperService);
        this.updateScreenSize();
    }

    onImageLoadError(e: any, src: string): void {
        e.target.src = src;
    }

    private updateScreenSize(): void {
        this.isSmallScreen = this.screenService.isSmallScreen();
        this.screenService.changed.subscribe(() => (this.isSmallScreen = this.screenService.isSmallScreen()));
    }
}
